import { Box, Button, Divider, Typography } from '@mui/material';
import PortraitOutlinedIcon from '@mui/icons-material/PortraitOutlined';
import ClientTable from './components/client-table';
import Header from './components/client-header';
import { RADIUS } from '../../../layouts/dashboard/config-layout';
import Add from '@mui/icons-material/Add';
import ClientController from '../controller/client-controller';
import CusttomAlertController from '../../../alert/controller/custom.alert.controller';
import { ClientChildrenModel, ClientModalChildrenData } from '../data/client-modal-child';
import { ClientModalNames } from '../data/client-modal-name';
import ClientModalView from './components/client-modal-view';
import CustomAlertModal from '../../../alert/components/custom.alert.modal';
import { useEffect } from 'react';
import useScreenWidth from '../../../hooks/use-page-width';

const ClientPage = () => {
  const client = ClientController();
  const alert = CusttomAlertController();
  const width = useScreenWidth();
  useEffect(() => {
    client.clientGetData(true, client.filter);
    client.getRoles();
    client.getPosition();
    client.getProvince();
    client.getMinistry();
    client.getDepartment();
  }, []);
  return (
    <>
      <Typography sx={{ px: 3, py: 2, color: '#f5f4f4' }}>ຈັດການຜູ້ໃຊ້ງານ</Typography>

      <Box sx={{ px: width > 600 ? 3 : 0, paddingBottom: '15px' }}>
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#f5f4f4',
            borderTopLeftRadius: width > 600 ? RADIUS.BORDERRADIUS : 0,
            borderTopRightRadius: width > 600 ? RADIUS.BORDERRADIUS : 0,
            borderBottomLeftRadius: width > 600 ? RADIUS.BORDERRADIUS : 0,
            borderBottomRightRadius: width > 600 ? RADIUS.BORDERRADIUS : 0,
          }}
        >
          <Box>
            <Header ctrl={client} />

            <Divider sx={{ backgroundColor: '#D9D9D9' }} />
            <Box
              paddingRight={'25px'}
              paddingLeft={'25px'}
              paddingBottom={'8px'}
              paddingTop={'8px'}
              display={'flex'}
              flexDirection={'row'}
              justifyContent={'space-between'}
            >
              <Typography
                fontSize={18}
                sx={{
                  display: 'flex',
                  justifyContent: 'start',
                  alignItems: 'center',
                  textWrap: 'nowrap',
                }}
              >
                <PortraitOutlinedIcon sx={{ marginRight: '10px' }} /> ຈັດການຜູ້ໃຊ້ງານ
              </Typography>
              <Box>
                <Button
                  variant="contained"
                  sx={{ borderRadius: 5, height: '40px' }}
                  onClick={() =>
                    client?.onHandleModal(
                      ClientModalChildrenData.filter((e: ClientChildrenModel) =>
                        e.name.includes(ClientModalNames.CREATE)
                      )[0]
                    )
                  }
                  fullWidth
                >
                  <Add /> ເພີ່ມຜູ້ໃຊ້ໃໝ່
                </Button>
              </Box>
            </Box>

            <ClientTable client={client} alert={alert} />
          </Box>
        </Box>
      </Box>
      <ClientModalView alert={alert} ctrl={client} />
      <CustomAlertModal ctrl={alert} />
    </>
  );
};

export default ClientPage;
